import React from 'react';
import { StyledImgBox } from 'views/information-module/common/components/UI/FranchiseTitleWithImg/FranchiseTitleWithImg.styles';
import Typography500 from 'views/common/components/UI/Typography500';

const FranchiseTitleWithImg = (props) => {
  const { title, image } = props;

  return (
    <>
      <Typography500 variant="h2" component="h1" mb={2}>
        {title}
      </Typography500>
      <StyledImgBox imgHeight="15.75rem" image={image} />
    </>
  );
};

export { FranchiseTitleWithImg };
